export const LuCardLabel = `Cartão Luiza`;
export const CreditCardLabel = `Cartão de crédito`;
export const BankSlipLabel = `Boleto bancário`;
export const PixLabel = `Pix`;
export const ProductPlusFreight = `(Produto + Frete)`;
export const InstallmentNumberLabel = `Numero de parcelas`;
export const TotalLabel = `Total`;
export const DiscountLabel = `% de desconto`;
export const SlipDescription = `No boleto bancário, que será gerado na finalização da sua compra.`;
export const PixDescription = `No PIX, com o código que será gerado na finalização da sua compra.`;
export const InstallmentLabel = installment => {
  return parseInt(installment, 10) >= 10 ? `${installment}x de` : `0${installment}x de`;
};
export const WithInterest = `com juros`;
export const WithoutInterest = `sem juros`;